<template>
  <b-modal :visible="visible" @hide="$emit('close')" :title="isEdit ? 'Редактирование предикта' : 'Новый предикт'" size="lg">
    <b-form @submit.prevent="$emit('save')">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="font-weight-bold">Название</label>
            <b-form-input :value="form.name" @input="$emit('update:name', $event)" placeholder="Название предикта"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="font-weight-bold">Описание</label>
            <b-form-textarea :value="form.description" @input="$emit('update:description', $event)" placeholder="Описание предикта" rows="2"></b-form-textarea>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="font-weight-bold">Стадия</label>
            <b-form-select
              :value="form.stage_id"
              :options="stageOptions"
              @change="$emit('stage-change', $event)"
            ></b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="font-weight-bold">Группа</label>
            <b-form-select
              :value="form.group_id"
              :options="groupOptions"
              :disabled="!form.stage_id"
              @input="$emit('update:group_id', $event)"
            ></b-form-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="font-weight-bold">Призовой фонд</label>
            <b-form-input :value="form.prize_fund" @input="$emit('update:prize_fund', $event)" placeholder="10000 USD"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="font-weight-bold">Длительность (мин)</label>
            <b-form-input :value="form.duration_minutes" @input="$emit('update:duration_minutes', Number($event))" type="number" placeholder="30"></b-form-input>
          </div>
        </div>
      </div>
    </b-form>

    <template #modal-footer>
      <b-button variant="secondary" @click="$emit('close')">Отмена</b-button>
      <b-button variant="primary" @click="$emit('save')" :disabled="!isFormValid">{{ isEdit ? 'Сохранить' : 'Создать' }}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "PredictionCreateModal",
  props: {
    visible: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    form: { type: Object, required: true },
    stageOptions: { type: Array, default: () => [] },
    groupOptions: { type: Array, default: () => [] },
  },
  computed: {
    isFormValid() {
      return this.form.stage_id && this.form.group_id;
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  display: block;
  margin-bottom: 0.5rem;
}
</style>